import { cn } from "@/lib/utils";

export default function PageHeader({ eyebrow, title, description, actions, testId }) {
  return (
    <div data-testid={testId} className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="mb-3 inline-flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-cyan-400 shadow-[0_0_8px_#00e5ff]" />
            <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/60">
              {eyebrow}
            </span>
          </div>
        )}
        <h1 className={cn(
          "font-display text-4xl sm:text-5xl lg:text-[52px] leading-[1.05] tracking-tight text-white"
        )}>
          {title}
        </h1>
        {description && (
          <p className="mt-4 text-[15px] leading-relaxed text-white/60 max-w-xl">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
